<!-- template for the modal component -->
<template>
<div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header_test">
            <slot name="header">

            </slot>
          </div>  

          <div class="modal-body">
            <slot name="body">
              default body
            </slot>
            <slot name="test">
              
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              
            </slot>
          </div>
          <button class="close-button"  @click="this.$root.ClosePopup();" style="margin-top: 10px; margin-bottom: 20px;">✖</button>
        </div>
      </div>
    </div>
</template>

<style>
#background{
    background-color: rgba(0, 0, 0, 0.95);
    border-radius: 10px 10px 10px 10px / 10px 10px 10px 10px;
    padding: 20px;
    border:2px solid #2d88ff ;
}
.main_container {
  overflow-y: auto;
  width: 780px;
  margin: 0px auto;
  padding: 0px 30px;
}
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-height: 100%; /* 모달의 최대 높이 설정 */
  overflow-y: auto; /* 세로 스크롤 적용 */
  background-color: rgba(0, 0, 0, 0.5);
  
  z-index: 1000;
  transition: opacity 0.3s ease;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.modal-mask::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera*/
}
.modal-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  box-sizing: border-box;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.modal-wrapper::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera*/
}

.modal-container {
  overflow-y: auto;
  width: 1200px;
  max-height: 100vh; /* 뷰포트 높이에서 여유 공간을 뺀 값으로 설정 */
  margin: 0px auto;
  padding: 10px 30px;
  
  font-family: Helvetica, Arial, sans-serif;

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.modal-container::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera*/
}

.modal-header {
  margin-top: 0;
  color: #42b983;
}
/* 
.modal-body {
  margin: -2px 0;
} */

.modal-default-button {
  float: right;
}

.close-button {
  width: 60px;
  height: 60px;
  border: 0px;
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  background-color: white;
  font-size: 30px;
  padding-right: 4px;
  padding-top: 4px;
}
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter-from, .modal-leave-to {
  opacity: 0;
}

.modal-enter-active .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>
